import axios from "axios";
import { useObserver } from "mobx-react";
import { useEffect, useState } from "react";
import {
  apiLink,
  interviewsList,
  publicStorgeLink,
} from "../../helpers/constantVariables";
import { useStores } from "../../store";
import { getInterview } from "../../api/recruiterAssessmentsApi";
import { FaCircleNotch } from "react-icons/fa";
import PdfViewer from "../reusble_components/pdfViewer";
import ReportOverview from "./ReportOverview";

export default function InterviewReport({ enable = true }) {
  const [interviewId, setInterviewId] = useState(null);
  const [interviewData, setInterviewData] = useState(null);
  const [recordingId, setrecordingId] = useState(null);
  const [isRecordAvailable, setisRecordAvailable] = useState(null);
  const [isResultGenerated, setIsResultGenerated] = useState(null);
  const [loading, setLoading] = useState(false);
  const { InterviewStore, CommonStore } = useStores();
  useEffect(() => {
    // getIdFromUrl();
    getTheInterviewData();
    //   try {
    //     if (topref.current) {
    //       topref.current.scrollIntoView({ behavior: "instant" });
    //     }
    //   } catch (error) {}
  }, [window.location.href]);

  const updateRecordingToServer = (id, storageLink) => {
    // this function will update the recording link to the server if the recording link is not available in the server
    if (
      interviewData?.recroding === undefined ||
      interviewData?.recroding === null
    ) {
      InterviewStore.updateInterviewById(id, { recording: storageLink });
    }
  };
  const getIdFromUrl = () => {
    try {
      const url = new URL(window.location.href);
      const pathname = url.pathname;
      const id = pathname.split("/").pop();
      console.log(id);
      setInterviewId(id);
      return id;
    } catch (error) {
      return null;
    }
  };
  const getTheResultByTopic = (topic) => {
    if (interviewData === null) return "";
    console.log(interviewData, "interview data");
    const result = interviewData?.result?.filter((q) => q?.name === topic);
    console.log(result, "interview data");

    return result && result[0]?.score;
  };
  const checkRecordedVideoAvailability = (id) => {
    if (isRecordAvailable !== null) return; // if already checked then return

    try {
      const storageLink = `${publicStorgeLink}/${id}.mp4`;

      // check if the video is available in the storage
      axios
        .get(storageLink)
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            setisRecordAvailable(true);
            updateRecordingToServer(id, storageLink);
          }
        })
        .catch((err) => {
          console.log(err);
          setisRecordAvailable(false);
        });
    } catch (error) {}
  };
  const getTheInterviewData = async () => {
    const id = getIdFromUrl();

    if (id === null) return alert("Invalid interview id from url");
    setLoading(true);
    setisRecordAvailable(null);
    try {
      const result = await getInterview(id);
      setLoading(false);
      console.log(result.body);
      if (
        (result?.status === 200 || result?.status === 201) &&
        result?.body?.success
      ) {
        const data = result?.body?.data;
        console.log(data, "candidate data");
        setInterviewData(data);
        setrecordingId(data?.recording);
        setIsResultGenerated(data?.isResultPublished);
        const recording = data?.recording;
        console.log(recording);
        if (recording) {
          setisRecordAvailable(true);
        } else {
          setisRecordAvailable(false);
          checkRecordedVideoAvailability(id);
        }
        return;
      }
      alert("Your report data not found");
    } catch (error) {
      console.log(error);
      // alert("Error Occured");
      console.log("Error Occured");
      setLoading(false);
    }
  };
  const getTheDurationBy2Time = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    // return mm:ss format
    const duration = Math.abs(end - start);
    const minutes = Math.floor(duration / 1000 / 60);
    const seconds = Math.floor((duration / 1000) % 60);
    return ` ${minutes}m:${seconds}s`;
  };
  const getInterviewTitle = (interviewId) => {
    const interview = interviewsList.find((item) => item.id === interviewId);
    return interview ? interview.title : "-";
  };
  const getRecordedTime = () => {
    try {
      if (InterviewStore.recordingTime) {
        return InterviewStore.recordingTime;
      } else if (
        interviewData?.interviewCompletedAt &&
        interviewData?.createdAt
      ) {
        return getTheDurationBy2Time(
          interviewData?.createdAt,
          interviewData?.interviewCompletedAt,
        );
      } else return "-";
    } catch (error) {
      return "-";
    }
  };

  const convertTimestampToDate = (timestamp) => {
    const date = new Date(timestamp);

    // Function to get the month name
    const getMonthName = (monthIndex) => {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      return months[monthIndex];
    };

    // Format the date to 'Month day, year' format
    const formattedDate = `${getMonthName(
      date.getMonth(),
    )} ${date.getDate()}, ${date.getFullYear()}`;

    return formattedDate;
  };
  const avgScore = (x, y) => {
    if (x && y) {
      return (x + y) / 2;
    } else {
      return;
    }
  };

  // const getTheResultByTopic = (topic) => {
  //   if (candidate === null) return "";
  //   const result = candidate?.result?.filter((q) => q?.name === topic);

  //   return result?.length > 0 ? result[0].score ?? 0 : 0;
  // };

  const getOverallScore = () => {
    try {
      const technicalScore = getTheResultByTopic("technical_score");
      const communicationScore = getTheResultByTopic("communication_score");
      const overallScore =
        (Number(technicalScore) + Number(communicationScore)) / 2;
      return overallScore;
    } catch (error) {
      return 0;
    }
  };

  const checkInterviewCompletionStatus = (interview) => {
    const questions =
      (interview?.noOfQuestions + (interview?.customQuestions?.length || 0)) *
      2;
    const messages = interview?.messages?.length || 0;
    if (questions - 2 <= messages) {
      return true;
    } else {
      return false;
    }
  };

  const reportData = [
    {
      title: "Interview Report",
      show: true,
      video: true,
      score: getOverallScore() === "Pending" ? 0 : getOverallScore(),
      videoData: {
        videoSrc: interviewData?.recording ?? "",
        onDownload: () => console.log("Downloading video 1"),
        title: "Technical Interview",
        image:
          interviewData?.proxyId?.snapShots?.length > 0
            ? interviewData?.proxyId?.snapShots[0].url
            : "",
      },
      // interviewData: interviewData,
      details: [
        {
          label: "Assesment Name:",
          value: interviewData?.technology,
        },
        // {
        //   label: "Level of interview:",
        //   value:
        //     interviewData
        //       ?.levelOfInterview,
        // },
        {
          label: "Cut off :",
          value: "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value: interviewData?.noOfQuestions,
        },
        {
          label: "Status:",
          value: "Not Mentioned",
        },
      ],
      questions: interviewData?.questions,
      showCheckDetails: true,
      reportId: interviewData?._id,
      technical: true,
      interviewId:
        interviewData &&
        interviewData?.result?.length === 0 &&
        checkInterviewCompletionStatus(interviewData)
          ? interviewData?._id
          : null,

      summerySuggestion: getTheResultByTopic("summerySuggestion"),
      interviewSuggestion: getTheResultByTopic("interviewSuggestion"),
    },
  ];

  const videoData = [
    {
      videoSrc: interviewData?.recording ?? "",
      onDownload: () => console.log("Downloading video 1"),
      title: "Technical Interview",
    },
  ];

  const candidate1 = {
    _id: interviewData?._id,
    id: interviewData?._id,
    name: interviewData?.interviewee?.name ?? "Mrudhul vij",
    jobPost: null,
    mobile: interviewData?.interviewee?.mobile ?? "-",
    resumeScore: interviewData?.resumeScore,
    labels: interviewData?.labels ?? [1, 2, 3],
    mcq: null,
    date: convertTimestampToDate(interviewData?.createdAt) ?? "mar 5, 2024",
    location: interviewData?.userId?.city ?? "Visakhapatnam",
    email: interviewData?.userId?.mail ?? "mrudhulpvij@gmail.com",
    jobRole: interviewData?.jobPostId?.jobTitle ?? "React developer",
    results: interviewData?.result ?? interviewData?.result ?? "Pending",
    technicalSkills: getTheResultByTopic("technical_score") || 0,
    communication: getTheResultByTopic("communication_score") || 0,
    overallScore: getOverallScore() === "Pending" ? 0 : getOverallScore(),
    result: interviewData?.result ?? "Pending",
    resumelink: interviewData?.resumeLink ?? "",
    resume: interviewData?.resume,
    mcq: false,
    hr: false,
    skills: interviewData?.interviewee?.skills,
    technical: getTheResultByTopic("technical_score") || 0,
    status: true,
    image: interviewData?.interviewee?.pic, // Replace with the actual image URL
    isShortlisted: interviewData?.isShortlisted ?? false,
    isRejected: interviewData?.isRejected ?? false,
    createdAt: interviewData?.createdAt,
    status: interviewData?.status,
    proxyId: interviewData?.proxyId?._id,
    proxy: {
      isOverallProxy: interviewData?.customSettings?.find(
        (setting) => setting.name === "proxy" && setting.value === true,
      )
        ? true
        : false,
      // isOverallProxy: true,
      interviewId: interviewData?.proxyId?.interviewId || "",
      proxyId: interviewData?.proxyId?._id || "",
      technicalInterviewProxyId: interviewData?.proxyId || "",
      // hrInterviewProxyId: interviewData?.proxyId,
      // codingInterviewProxyId:
      //   interviewData?.proxyId,
      tabChanges: Number(interviewData?.proxyId?.tabChanges?.count || 0),
      faceOutOfView: Number(interviewData?.proxyId?.faceOutOfView?.count || 0),
      multipleFacesDetected: Number(
        interviewData?.proxyId?.multipleFacesDetected?.count - 1 || 0,
      ),
      textDetection: Number(interviewData?.proxyId?.textDetection?.count || 0),
      multipleVoicesDetected: Number(
        interviewData?.proxyId?.multipleVoicesDetected?.count || 0,
      ),
    },
  };

  const interviewDetailsArray = [
    {
      label: "Interviewee:",
      value: interviewData?.interviewee?.name,
    },
    {
      label: "Interview Type:",
      value: getInterviewTitle(interviewData?.interviewId),
    },
    {
      label: "Duration:",
      value: getRecordedTime(),
    },
    {
      label: "Interviewer:",
      value: interviewData?.interviewerName ?? "Lucy",
    },
    {
      label: "Topic:",
      value:
        interviewData?.technology === ""
          ? interviewData?.role
          : interviewData?.technology,
    },
    {
      label: "ID:",
      value: interviewData?._id ?? "-",
    },

    {
      label: "Level:",
      value: interviewData?.levelOfInterview,
    },
  ];

  return useObserver(() => (
    <div className="w-full">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center z-50">
          <div className="flex flex-col items-center">
            <FaCircleNotch className="animate-spin text-primary text-4xl mb-2" />
            <p>Loading...</p>
          </div>
        </div>
      )}
      {CommonStore.resume && (
        <PdfViewer
          pdfUrl={CommonStore.jobresume}
          onClose={() => CommonStore.setResume(false)}
        />
      )}
      {/* <div className="flex justify-between w-[95%] items-center ">
        <h2 className="text-xl flex items-center gap-4 font-semibold mb-4 pt-4 pl-4 md:pt-8 md:pl-8 mx-2 sm:mx-8 md:mx-8 lg:mx-14">
          Overview{" "}
          <p className="text-[#747474] md:block lg:block hidden opacity-50 text-sm font-semibold">
            Id : {interviewData?._id}
          </p>
        </h2>

        <button
          className="flex flex-row items-center justify-around gap-1 border border-primary px-4 text-primary h-8 rounded-lg text-sm"
          onClick={() => {
            CommonStore.setResume(true);
            CommonStore.setJobResume(interviewData?.resumeLink);
          }}
        >
          <AiOutlineFileText />
          Resume
        </button> 
      </div> */}
      {/* <div className="md:mt-11">
        <InterviewApplicant candidate={interviewData} candidate1={candidate1} />
      </div> */}

      {/* <div>
        <Behaviour
          professionalScore={getTheResultByTopic("professionalism_score")}
          positivenessScore={getTheResultByTopic("positiveness_score")}
          // communicationScore={getTheResultByTopic("communication_score")}
          sociabilityScore={getTheResultByTopic("sociability_score")}
        />
      </div> */}
      {/* <div className="w-full px-5">
        <div className="flex flex-col sm:flex-row md:flex-row lg:flex-row justify-evenly h-[60%] m-4 sm:m-8 md:m-10 lg:m-14">
          <VideoPlayer
            title={"Record session"}
            videoSrc={interviewData?.recording ?? ""}
          />
        </div>
      </div> */}
      <div className="p-4 md:p-4 mx-2 sm:mx-8 md:mx-0 lg:mx-14 md:mt-7">
        <ReportOverview
          candidate={candidate1}
          reportData={reportData}
          videoData={videoData}
          enable={enable}
          isJobPost={false}
          isHrInterviewCompleted={interviewData?.isInterviewCompleted}
          // loader={isLoading}
          // recruiter={recruiter}
          proxy={false}
        />
        {/* <ReportCard
          details={interviewDetailsArray}
          title={"Interview Details"}
        />
        <ReportCard
          questions={interviewData?.questions}
          title={"Questions and answers"}
        />
        <ReportCard
          Suggestions={getTheResultByTopic("interviewSuggestion")?.split(
            "\n\n"
          )}
          title={"Suggestions"}
        />
        <ReportCard
          Summary={getTheResultByTopic("summerySuggestion")}
          title={"Summary"}
        /> */}
      </div>
    </div>
  ));
}
